<template>
    <el-card shadow="never" class="aui-card--fill">
      
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="审批可提现记录" name="first" key="1">
               <tableApproval ref="table1"></tableApproval>
            </el-tab-pane>
            <el-tab-pane label="申请提现记录" name="second" key="2">
                <tableApply  ref="table2" ></tableApply>
            </el-tab-pane>
            <el-tab-pane label="已打款记录" name="third" key="3">
                <tableRemit ref="table3" ></tableRemit>
            </el-tab-pane>
          
        </el-tabs>
   
    </el-card>
 
</template>

<script>

import tableApproval from '@/components/wx/tableApproval.vue'
import tableApply from '@/components/wx/tableApply.vue'
import tableRemit from  '@/components/wx/tableRemit.vue'
export default {
    data() {
      return {
        activeName: 'first'
      };
    },
    components: {
        tableApproval,
        tableApply,
        tableRemit,
    },
    methods: {
        handleClick(tab, event) {
            this.$refs.table1.query()
            this.$refs.table2.query()
            this.$refs.table3.query()
      }
    }
}
</script>

<style>

</style>